import { isSameDay as isSameDay$1, isWithinInterval, format, addYears, addMonths, addWeeks, addDays, startOfWeek, parseISO, endOfWeek, eachDayOfInterval } from "date-fns";
const shiftDate = (date, period, amount = 1) => {
  switch (period) {
    case "day":
      return addDays(date, amount);
    case "week":
      return addWeeks(date, amount);
    case "month":
      return addMonths(date, amount);
    case "year":
      return addYears(date, amount);
  }
};
const isDateBefore = (date1, date2) => new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0);
const isSameDay = (date1, date2) => isSameDay$1(date1, date2);
const isWithinTimeSpan = (date, start, end) => isWithinInterval(date, { start, end });
const parseDate = (date) => typeof date === "string" ? parseISO(date) : date;
const toLocalDate = (date) => format(date, "yyyy-MM-dd");
const toLocalTimeMinutes = (date) => format(date, "HH:mm");
const getWeekDaysByDate = (date = /* @__PURE__ */ new Date(), weekStartOffset) => {
  const start = addDays(startOfWeek(parseDate(date)), weekStartOffset || 0);
  const end = addDays(endOfWeek(parseDate(date)), weekStartOffset || 0);
  return eachDayOfInterval({ start, end });
};
const getWeekDaysByDates = (dates, weekStartOffset) => dates.map((date) => getWeekDaysByDate(date, weekStartOffset));
const adjustOffsetToAccountForHiddenDays = (date, weekStartDay) => {
  const isDayThatIsHidden = date.getDay() < weekStartDay;
  const adjustedOffset = (7 - weekStartDay) * -1;
  return isDayThatIsHidden ? adjustedOffset : weekStartDay;
};
const numberOfWeeksToShow = 2;
const firstDayOfWeek = 1;
const getWeekDaysForWeeksFromDate = (date, weeks = numberOfWeeksToShow, weekStartOffset = firstDayOfWeek) => {
  const dates = [];
  let i = 0;
  while (i < weeks) {
    dates.push(shiftDate(date, "week", i));
    i++;
  }
  return getWeekDaysByDates(dates, adjustOffsetToAccountForHiddenDays(date, weekStartOffset ?? 0));
};
const getDayLabel = (date, size) => {
  const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
  ];
  return `appointments.${size}Days.${days[date.getDay()]}`;
};
export {
  adjustOffsetToAccountForHiddenDays,
  getDayLabel,
  getWeekDaysByDate,
  getWeekDaysByDates,
  getWeekDaysForWeeksFromDate,
  isDateBefore,
  isSameDay,
  isWithinTimeSpan,
  parseDate,
  shiftDate,
  toLocalDate,
  toLocalTimeMinutes
};
//# sourceMappingURL=datetime.js.map
